"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _utils = require("../../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BanOption = function BanOption(_ref) {
  var option = _ref.option,
    onBanSuccess = _ref.onBanSuccess,
    userId = _ref.userId,
    channelId = _ref.channelId;
  var _useRequest = (0, _utils.useRequest)(function (userId, channel, timeout) {
      return {
        url: (0, _utils.getBanUserUrl)(channel, userId),
        method: 'post',
        data: {
          timeout: timeout
        }
      };
    }, {
      manual: true,
      onSuccess: onBanSuccess
    }),
    banningUser = _useRequest.loading,
    banUser = _useRequest.run;
  var onBanClick = function onBanClick(option) {
    if (option.action === _constants.BAN_ACTION_TYPES.FROM_ALL_PUBLIC_CHANNELS || option.action === _constants.BAN_ACTION_TYPES.FROM_CHANNEL) {
      banUser(userId, option.action === _constants.BAN_ACTION_TYPES.FROM_CHANNEL ? channelId : undefined, option.timeout);
    } else {
      console.error("action: ".concat(option.action, " is not supported"));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    style: {
      display: 'block'
    },
    loading: banningUser,
    onClick: function onClick() {
      onBanClick(option);
    }
  }, option.label);
};
var _default = BanOption;
exports.default = _default;